<ep-location-form [form]="locationForm" [mode]="(mode$ | async)!"></ep-location-form>
